/* eslint-disable import/prefer-default-export */
export function loadScript(src, cb) {
  if (!src) {
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    const dom = document.createElement('script');
    dom.onload = cb || (() => resolve());
    dom.type = 'text/javascript';
    dom.onerror = reject;
    dom.src = src;
    document.body.appendChild(dom);
  });
}
